import {
  Body,
  Caption,
  VButton,
  VDropdownMenu,
  VDropdownMenuContent,
  VDropdownMenuItem,
  VDropdownMenuRadioGroup,
  VDropdownMenuRadioItem,
  VDropdownMenuSeparator,
  VDropdownMenuSub,
  VDropdownMenuSubContent,
  VDropdownMenuSubTrigger,
  VDropdownMenuTrigger,
} from '@vrzl/ui';
import { ArrowLeftRight, LogOut } from 'lucide-react';
import { useNavigate } from 'react-router';

import { useAuth } from './authProvider';
import { switchablePerspectives } from './switchablePerspectives';

export function UserBadge() {
  const { user, logout, switchPerspective } = useAuth();
  const navigate = useNavigate();

  if (!user) return null;

  const perspectives = switchablePerspectives(user);
  const activePerspectiveId = user.activePerspective?.id;

  async function handleLogout() {
    try {
      await logout();
    } finally {
      navigate('/login', { replace: true });
    }
  }

  function handlePerspectiveChange(perspectiveId: string) {
    if (perspectiveId === activePerspectiveId) return;
    void switchPerspective(perspectiveId);
  }

  return (
    <VDropdownMenu>
      <VDropdownMenuTrigger asChild>
        <VButton
          type="button"
          variant="ghost"
          className="ml-4 h-auto shrink-0 cursor-pointer gap-3 px-3 py-2 hover:bg-muted focus:outline-none focus-visible:ring-2 focus-visible:ring-neutral-500"
        >
          <div className="text-right">
            <Body weight="medium">{user.name}</Body>
            {user.activePerspective ? (
              <Caption>{user.activePerspective.name}</Caption>
            ) : null}
          </div>
          <div className="flex size-9 items-center justify-center rounded-full bg-perspective-600">
            <Body as="span" weight="semibold" tone="on-primary">
              {user.initials}
            </Body>
          </div>
        </VButton>
      </VDropdownMenuTrigger>

      <VDropdownMenuContent align="end" className="min-w-44">
        {perspectives.length > 0 ? (
          <>
            <VDropdownMenuSub>
              <VDropdownMenuSubTrigger>
                <ArrowLeftRight className="size-4" />
                <span>Wissel perspectief</span>
              </VDropdownMenuSubTrigger>
              <VDropdownMenuSubContent className="min-w-40">
                <VDropdownMenuRadioGroup
                  value={activePerspectiveId ?? ''}
                  onValueChange={handlePerspectiveChange}
                >
                  {perspectives.map((perspective) => (
                    <VDropdownMenuRadioItem key={perspective.id} value={perspective.id}>
                      {perspective.name}
                    </VDropdownMenuRadioItem>
                  ))}
                </VDropdownMenuRadioGroup>
              </VDropdownMenuSubContent>
            </VDropdownMenuSub>
            <VDropdownMenuSeparator />
          </>
        ) : null}
        <VDropdownMenuItem onSelect={handleLogout}>
          <LogOut className="size-4" />
          <span>Uitloggen</span>
        </VDropdownMenuItem>
      </VDropdownMenuContent>
    </VDropdownMenu>
  );
}
